var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('h6',[_vm._v("กราฟรายได้")]),_c('div',{attrs:{"id":"charts"}},[_c('apexchart',{ref:"realtimeChart",attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }